export default {
      id: "menu__help_fill-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.svg#menu__help_fill",
      toString: function () {
        return this.url;
      }
    }